<template>
    <div class="cover-content form-wrapper">
        <div class="ft-box">
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>考勤统计</span>
            </div>
            <div v-for="(item, index) in arrDate1" :key="index">
                <div>
                  <span>{{ item.projectName }}</span>
                  <span v-if="item.exitStatus && !item.exitDate">（已退场）</span>
                  <span v-if="item.exitStatus && item.exitDate">（已于{{item.exitDate}}退场）</span>
                </div>
                <div class="attendanceLegend">
                <div class="attendanceLegend_left">
                    <attendanceCalendar
                    :workerId="workerId"
                    :dataObj="item"
                    ></attendanceCalendar>
                </div>
                <div class="attendanceLegend_right">
                    <div class="attendanceLegend_rightbig">
                    <attendanceTrend
                        :workerId="workerId"
                        :trendData="item"
                    ></attendanceTrend>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="ft-box cover-table" style='margin-bottom: 0' >
            <div class="ft-title aFlex">
                <Icon class="ft-title-mark" type="md-bookmark" />
                <span>人员考勤详情</span>
            </div>
            <Table border size="large" :loading="loading"
                   :columns="tableColumns" :data="tableData" highlight-row>
                <!--<template slot-scope="{ row, index }" slot="action">

                </template>-->
            </Table>
            <Page class='page' :total="totalCount" :page-size="pageSize" :current="page"
                    @on-change="changePage" @on-page-size-change="pageSizeChange"
                    show-elevator show-sizer show-total transfer>
            </Page>
        </div>

    </div>
</template>
<style scoped>
.attendanceLegend {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.attendanceLegend_left {
  width: 49%;
  height: 435px;
  border: 2px solid #828282;
}
.attendanceLegend_right {
  width: 49%;
  height: 435px;
  background-color: #f0f2f5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.attendanceLegend_rightbig {
  width: 95%;
  height: 95%;
  background-color: #dfebff;
  /* margin: auto;
    margin-top: 10px; */
}
</style>
<script>
import attendanceCalendar from '@/components/attendanceCalendar';
import attendanceTrend from '@/components/attendanceTrend';
import tableMixin from '@/components/tableMixin';
export default {
  mixins: [tableMixin],
  components: {
    attendanceCalendar,
    attendanceTrend,
  },
  data(){
    return {
      currDate1: '', //日历初始时间
      arrDate1: [], //日历初始项目考勤列表信息
      rprojectId: '', //日历初始获取项目id
      currDate: '', //日历时间变化时的时间点
      workerId: '',//传入workerid
      loading: false,
      projectWorkerId:'',
      formInline:{
        type:'主管部门',
        SubmitDate:'',
      },
      tableColumns:[
        {
          title: '序号',
          type: 'index',
          fixed: 'left',
          width: 70,
          align: 'center'
        },
        {
          title: '姓名',
          key: 'workerName',
        },
        {
          title: '刷卡时间',
          key: 'workDate'
        },
          {
              title: '上传时间',
              key: 'date'
          },
        {
          title: '出入方向',
          key: 'direction'
        },
        {
          title: '项目名称',
          key: 'projectName'
        },
        {
          title: '班组名称',
          key: 'teamName'
        },
        {
          title: '工种',
          key: 'workType'
        }
      ],
      tableData:[],
    };
  },
  computed:{

  },
  beforeRouteEnter(to,from,next){
    if(from.name == 'checking-inList'){
      to.meta.pname = 'checking-inList';
    }else {
      to.meta.pname = 'postList';
    }
    next();
  },
  created(){
    this.projectWorkerId= this.$route.query.projectWorkerId;
    this.workerId=this.$route.query.workerId;
    // console.log(this.$route.query.workerId,88888888888888);
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : '0' + month;
    this.currDate1 = `${year}-${month}`;
    this.getCheckList1();
  },
  mounted(){

  },
  watch: {

  },
  methods: {
    /*获取表格数据*/
    getTableData(){
      this.loading=true;
      this.axios({
        method: 'get',
        url: '/worker/attendance/detail',
        params:{
          size:this.pageSize,
          current:this.page,
          projectWorkerId:this.projectWorkerId
        }
      }).then( (response)=> {
        this.loading=false;
        if (response.data.success){
          this.tableData=response.data.data.records || [];
          this.totalCount=response.data.data.total;
        }
      }).catch(()=> {
        this.loading=false;
      });
    },
    // 初始获取考勤列表数据
    getCheckList1() {
      this.loading = true;
      this.axios({
        method: 'get',
        url: '/project/workers/projectCalendar',
        params: {
          // workerId:'10344',
          workerId: this.workerId,
          // projectId:this.projectId,
          // corpId:this.corpId,
          date: this.currDate1,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            console.log(response, '7777777777');
            this.arrDate1 = response.data.data;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  }
};
</script>
